<template>
  
  <div v-if="show" class="important-message">
    <font-awesome-icon class="icon" icon="exclamation-triangle" />
   {{appSettings.school_app_important_msg}}
  </div>
 
</template>

<script>
import { mapState } from 'vuex'
//import i18n from "../language.js";

export default {
  name: 'important-message',
  props:{
  },
  data(){
    return {
      show:false,
    }
  },
  components: {
  },
  computed:{
      ...mapState([
    'appSettings'
    ]),
  },
  methods:{
    
  },
  mounted:function(){
    // to implement languages we got to check i18n locale
    // for now we dont
    // i18n.locale
   if(this.appSettings.school_app_important_msg){
     this.show=true;
   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.important-message{
  padding:10px;
  border:1px solid #FF0000;
  color:#000000;
  background-color:#ffdddd;
  margin:8px;
  border-radius:2px;
}


.icon{
  color:#FF0000;
  animation-name: example;
  animation-duration: 1s;
  animation-iteration-count: infinite;

}

@keyframes example {
  0%   {transform:scale(1);}
  20%  {transform:scale(1.3);}
  40%  {transform:scale(1);}
  100%  {transform:scale(1);}
}

</style>
